import { Link } from "@tanstack/react-router";
import { Menu } from "lucide-react";
import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "../ui/button";

export default function MobileNavMenu() {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild className="mr-4">
        <Button variant="ghost">
          <Menu className="h-12 w-12" />
          <span className="sr-only">Toggle navigation menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[250px] sm:w-[300px]">
        <SheetHeader>
          <SheetTitle>Navigation</SheetTitle>
        </SheetHeader>
        <div className="flex flex-col space-y-2">
          <Link
            to="/tutors"
            className="px-2 py-2 text-lg hover:bg-gray-100 rounded-md"
            onClick={() => setOpen(false)}
          >
            Tutors
          </Link>
          <Link
            to="/classes/browse"
            className="px-2 py-2 text-lg hover:bg-gray-100 rounded-md"
            onClick={() => setOpen(false)}
          >
            Classes Catalog
          </Link>
        </div>
      </SheetContent>
    </Sheet>
  );
}
